export default __webpack_public_path__ + "static/media/fundo-rosa-baixo.4f9174cb.png";